export enum UserRole {
  Admin = "ADMIN",
  User = "USER",
}
